export default __webpack_public_path__ + "static/media/protect-workstations.469dff90.jpg";